<script>
import dayjs from 'dayjs'

export default {
  props: {
    notes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    // Log the user out
    deleteNote(_note) {},
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
}
</script>

<template>
  <div>
    <div v-for="(note, i) in notes" :key="i" class="note">
      <p>{{ note.meta }}</p>
      <div>
        <a-icon type="number" />
        {{ note.sk.replace('USER#', '') }} &middot;
        {{ formatDate(note.created_at) }}
        <a-button
          type="danger"
          size="small"
          shape="circle"
          @click="$emit('delete-note', note)"
        >
          <a-icon type="delete" />
        </a-button>
      </div>
      <a-divider />
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';
.note {
  button {
    margin-left: 8px;
  }
}
</style>
